// extracted by mini-css-extract-plugin
module.exports = {"entry":"headerLogo__entry"};